import React from "react";
import { useMessageSource } from "react-message-source";
import RadioButtonField from "../formik/radiobutton";

interface PersonType {
  gender?: string;
  firstName: string;
  lastName: string;
}

export interface ChoosePersonOptionType {
  id: string;
  value: string;
  messageKey: string;
  person?: PersonType;
}

function useLabelText(messageKey: string, person: PersonType) {
  const { getMessage, getMessageWithNamedParams } = useMessageSource();

  if (person) {
    return getMessageWithNamedParams(messageKey, {
      gender:
        person.gender === "FEMALE"
          ? getMessage("Gender.MS")
          : getMessage("Gender.MR"),
      firstName: person.firstName,
      lastName: person.lastName,
    });
  }

  return getMessage(messageKey);
}

function toTranslatedOptions(options: ChoosePersonOptionType[]) {
  return options.map((o) => {
    return {
      id: o.id,
      value: o.value,
      label: useLabelText(o.messageKey, o.person),
    };
  });
}

export default function ChoosePerson({
  title,
  subTitle,
  id,
  values,
  name,
  note,
  onChange,
}: {
  id: string;
  values: ChoosePersonOptionType[];
  title?: string;
  subTitle?: string;
  name?: string;
  note?: string;
  onChange?: (event: React.SyntheticEvent, value: string) => void;
}): React.JSX.Element {
  return (
    <RadioButtonField
      title={title}
      subTitle={subTitle}
      id={id}
      values={toTranslatedOptions(values)}
      name={name}
      descriptionText={note}
      onChangeCallback={onChange}
    />
  );
}
